import React, { useState } from "react";
import "./Packages.css";

const Packages = () => {
  const [expandedPackage, setExpandedPackage] = useState(null);

  const packages = [
    {
      id: 1,
      title: "Sole Trader/PAYE",
      price: "€150-250",
      priceNote: "(add-ons)",
      icon: "fa-solid fa-user",
      description:
        "Comprehensive tax and compliance services for individuals and sole traders.",
      features: [
        "Annual Income Tax Return (Form 11)",
        "Revenue compliance",
        "Basic tax planning (add-on)",
        "Email support (add-on)",
        "Preliminary tax calculation (add-on)",
        "PAYE tax rebates (conditional on 15% commission)",
      ],
      suitableFor: ["Freelancers", "Tradespeople", "Uber/taxi drivers"],
      suitableIcon: "fa-solid fa-users",
      color: "#ed8936",
    },
    {
      id: 2,
      title: "Small-Medium Enterprises",
      price: "€150-500",
      priceNote: "(may vary upon add-ons)",
      icon: "fa-solid fa-building",
      description:
        "Complete financial management solutions for growing businesses.",
      features: [
        "Monthly bookkeeping review",
        "VAT returns",
        "Payroll for 1-3 employees",
        "Annual accounts (add-on)",
        "Corporation tax return (add-on)",
        "CRO filing (add-on)",
        "Management reports (add-on)",
      ],
      suitableFor: [
        "Small businesses",
        "Growing enterprises",
        "Family businesses",
      ],
      suitableIcon: "fa-solid fa-briefcase",
      color: "#2b6cb0",
    },
    {
      id: 3,
      title: "Start-up Business",
      price: "€250",
      priceNote: "(add-ons)",
      icon: "fa-solid fa-rocket",
      description:
        "Everything you need to launch your business with confidence.",
      features: [
        "CRO registration",
        "Company formation",
        "Revenue Registration",
        "Email support (add-on)",
        "Business Bank Account creation",
      ],
      suitableFor: ["New entrepreneurs", "Startups", "Business founders"],
      suitableIcon: "fa-solid fa-lightbulb",
      color: "#38a169",
    },
  ];

  const togglePackage = (id) => {
    setExpandedPackage(expandedPackage === id ? null : id);
  };

  return (
    <section className="packages section" id="packages">
      <div className="container">
        <div className="packages-header">
          <h2>Our Packages</h2>
          <p>
            Choose the perfect package for your needs. All packages include
            professional support and can be customized with add-ons.
          </p>
        </div>

        <div className="packages-grid">
          {packages.map((pkg) => {
            const isExpanded = expandedPackage === pkg.id;

            return (
              <div
                key={pkg.id}
                className={`package-card ${isExpanded ? "expanded" : ""}`}
                style={{ "--card-color": pkg.color }}
              >
                {/* Card Header */}
                <div className="package-header">
                  <div className="package-icon" style={{ color: pkg.color }}>
                    <i className={pkg.icon}></i>
                  </div>
                  <h3 className="package-title">{pkg.title}</h3>
                </div>

                {/* Price */}
                <div className="package-price">
                  <span className="price-amount">{pkg.price}</span>
                  <span className="price-note">{pkg.priceNote}</span>
                </div>

                {/* Description */}
                <p className="package-description">{pkg.description}</p>

                {/* Features List */}
                <div className="package-features">
                  <h4>What's Included:</h4>
                  <ul>
                    {pkg.features.map((feature, index) => (
                      <li key={index}>
                        <i
                          className="fa-solid fa-check"
                          style={{ color: pkg.color }}
                        ></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Suitable For - Shows when expanded */}
                {isExpanded && (
                  <div className="package-suitable">
                    <h4>
                      <i className={pkg.suitableIcon}></i>
                      Suitable for you if you are:
                    </h4>
                    <ul>
                      {pkg.suitableFor.map((item, index) => (
                        <li key={index}>
                          <i
                            className="fa-solid fa-user-check"
                            style={{ color: pkg.color }}
                          ></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Toggle Button */}
                <button
                  className="package-toggle-btn"
                  onClick={() => togglePackage(pkg.id)}
                  style={{ color: pkg.color }}
                >
                  {isExpanded ? "Show Less ▲" : "Show More..."}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Packages;
